<template>
  <!-- <MainPage></MainPage> -->
  <!-- <router-view></router-view> -->
  <component :is="currentTab[isainfo]"></component>
</template>

<script setup>
import { ref, reactive, markRaw } from "vue";
import MainPage from "@/views/MainPage.vue";
import Mobile from "@/views/Mobile.vue";
const WIDTH = 375;
const setView = () => {
  //设置html标签的fontSize
  document.documentElement.style.fontSize = (50 * screen.width) / WIDTH + "px";
};
window.onresize = setView; // 如果窗口大小发生改变，就触发 setView 事件
setView();
// const router = useRouter();
const IScomponent = reactive([
  { name: "MainPage", tabComp: markRaw(MainPage) },
  { name: "Mobile", tabComp: markRaw(Mobile) },
]);
const currentTab = reactive({
  MainPage: IScomponent[0].tabComp,
  Mobile: IScomponent[1].tabComp,
});
const isainfo = ref('MainPage')
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  isainfo.value = 'Mobile'
} else {
  isainfo.value = 'MainPage'
}
</script>

<style lang="less">
@import url("@/assets/reset.css");
@import url("@/assets/font/font.less");
@import url("@/assets/font/font.css");
</style>
